import React, {useState, useEffect} from "react";
import styled from "styled-components";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {DefinedRange,DateRange} from 'react-date-range';
import { compareDesc,differenceInDays,addDays,startOfWeek,endOfWeek,startOfMonth,startOfDay,endOfDay,endOfMonth,addMonths } from 'date-fns';
import Button from './Button';
import Switch from './Switch';
import './CalendarComplex.scss';
import {createStaticRanges} from '../../helpers/Calendar';
const Label = styled.span`
  font-size:12px;
  color:rgb(0,0,0,0.7);
  font-weight:600;
  text-transform: uppercase;
`;
const LabelContainer = styled.div`
  position:absolute;
  margin: 8px 16px;
`;
function CalendarComplex (props){
  const [labelPrinciapal, setLabelPrincipal] = useState("Semana Anterior");
  const [labelCompare, setLabelCompare] = useState("Periodo Anterior");
  const [compare, setCompare] = useState(false);
 
  const [showCompareOptions, setShowCompareOptions] = useState(false);
  const [rangesVirtual, setRangesVirtual] = useState({
    principal:{
      label:'Semana Anterior',
      startDate: startOfWeek(addDays(new Date(),-7),{weekStartsOn:1}),
      endDate: endOfWeek(addDays(new Date(),-7),{weekStartsOn:1}),
      key: 'principal'
    }
  });
  const [compareKey,setCompareKey] = useState('Periodo Anterior')
  const [daysToCompare, setDaysToCompare] = useState({
    startDate: -7,
    endDate: -1,
  });
  const defineds = {
    startOfWeek: startOfWeek(new Date(),{weekStartsOn:1}),
    endOfWeek: endOfWeek(new Date(),{weekStartsOn:1}),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7),{weekStartsOn:1}),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7),{weekStartsOn:1}),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  };
  const principalRanges = createStaticRanges([
    {
      label: 'Hoy',
      range: () => ({
        startDate: defineds.startOfToday,
        endDate: defineds.endOfToday,
        label:'Hoy'
      }),
      
    },
    {
      label: 'Ayer',
      range: () => ({
        startDate: defineds.startOfYesterday,
        endDate: defineds.endOfYesterday, 
        label:'Ayer'

      }),
    
    },
    {
      label: 'Esta Semana',
      range: () => ({
        startDate: defineds.startOfWeek,
        endDate: defineds.endOfWeek,
        label:'Esta Semana'

      }),
      
    },
    {
      label: 'Semana Anterior',
      range: () => ({
        startDate: startOfWeek(addDays(new Date(),-7),{weekStartsOn:1}),
        endDate: endOfWeek(addDays(new Date(),-7),{weekStartsOn:1}),
        label:'Semana Anterior'

      }),
    },
    {
      label: 'Este Mes',
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfMonth,
        label:'Este Mes'

      }),
    },
    {
      label: 'Mes Anterior',
      range: () => ({
        startDate: defineds.startOfLastMonth,
        endDate: defineds.endOfLastMonth,
        label:'Mes Anterior'

      }),
      
    },
  ]);
  const compareRanges = createStaticRanges([
    {
      label: 'Periodo Anterior',
      range: () => ({
        startDate: addDays(rangesVirtual.principal.startDate,daysToCompare.startDate),
        endDate: addDays(rangesVirtual.principal.startDate,daysToCompare.endDate),
        label: 'Periodo Anterior',

      }),
      
    },
    {
      label: 'Mismo periodo del año pasado',
      range: () => ({
        startDate: addDays(rangesVirtual.principal.startDate,-365),
        endDate: addDays(rangesVirtual.principal.endDate,-365), 
        label: 'Mismo periodo del año pasado',

      }),
    
    },
   
    {
      label: 'Personalizado',
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
        label: 'Personalizado',

      }),
    },
  ]);
  function handleCompare(){
    //si esta en false pasara a true
    if(!compare){
      setRangesVirtual({principal:rangesVirtual.principal,
        compare:{
          startDate: addDays(rangesVirtual.principal.startDate,daysToCompare.startDate),
          endDate: addDays(rangesVirtual.principal.startDate,daysToCompare.endDate),
          key: 'compare',
          label:'Periodo Anterior'
        }
      });
    }
    else{
      setRangesVirtual({principal:rangesVirtual.principal});
    }
    setCompare(!compare);
    setShowCompareOptions(!compare);
  }

  function toogleDateRange(item, handle=false){
    console.log("item",item);
    let key = Object.keys(item)[0];
    item[key].label = handle?'Personalizado':item[key].label
    let label = item[key].label;
    //cambiamos
    setRangesVirtual({...rangesVirtual,...item})
   

    if(key === "principal"){
      setLabelPrincipal(label);
        console.log("actuaalizo el compare");
        changeCompare(item[key],compare);
    }
    else{
      setLabelCompare(label);
      setCompareKey(label);
    }
  }
  useEffect(()=>{
    props.toogleDateRange(rangesVirtual);
  },[rangesVirtual])
  function changeCompare(item,apply = false){
    switch (compareKey) {
      case 'Periodo Anterior':
        let diferencia = differenceInDays(item.startDate,item.endDate);
        //console.log(diferencia-1); return true;
        setDaysToCompare({
          startDate: diferencia-1,
          endDate: -1,
        })
        if(apply){
          setRangesVirtual({principal:{...item},compare:{
            startDate: addDays(item.startDate,diferencia-1),
            endDate: addDays(item.startDate,-1),
            key: 'compare',
            label:'Periodo Anterior'
          }})
        }
        
        break;
      case 'Mismo periodo del año pasado':
        setDaysToCompare({
          startDate: -365,
          endDate: -365,
        })
        if(apply){
          setRangesVirtual({principal:{...item},compare:{
            startDate: addDays(item.startDate,-365),
            endDate: addDays(item.endDate,-365),
            key: 'compare',
            label:'Mismo periodo del año pasado'
          }})
        }
        
        break;
      default:
        break;
    }
    
    
  }
  useEffect(()=>{
    props.toogleComparar(compare);
  },[compare])
  function handleApply(){
    
    props.apply();
  }
  
  return (
  <div id="calendar-complex-container">
    <div id="selection-date-container" style={{display:'flex'}}>
      <div id="selection-container" className="cc-border-right" style={{width:'225px',maxHeight:'466px',overflowY:'auto',overflowX:'hidden'}}>
        <DefinedRange
          staticRanges={principalRanges}
          onChange={item => toogleDateRange(item)}
          ranges={[rangesVirtual.principal]}
        />
        <div className="cc-border-top"  style={{padding:'8px 20px 0', display:'flex', justifyContent:'space-between'}}>
          <span style={{fontSize:'12px'}}> Compare</span>
          <Switch 
            checked={compare} 
            onChange={handleCompare} 
          />  
        </div>
        <div style={{display:showCompareOptions?'':'none'}}>
        <DefinedRange
           staticRanges={compareRanges}
          onChange={item => toogleDateRange(item)}
          ranges={compare?[rangesVirtual.compare]:[]}
        />
        </div>
        
      </div>
      <div id="calendar-container">
        <LabelContainer>
          <Label>{labelPrinciapal}</Label>
        </LabelContainer>
        <LabelContainer style={{top:'58px', display:compare?'':'none'}}>
          <Label>Comparar: {labelCompare}</Label>
        </LabelContainer>
        {/* <div>
          <span>Label Compare</span>
        </div> */}
        <DateRange
          shownDate={defineds.startOfLastMonth}
          maxDate={defineds.endOfMonth}
          showMonthAndYearPickers={true}
          showMonthArrow={true}
          dateDisplayFormat={"d MMM yyyy"}
          rangeColors={["rgb(2,136,209,0.3)", "rgb(255, 208, 21,0.3)"]}
          weekStartsOn={1}
          direction="horizontal"
          months={2}
          editableDateInputs={true}
          onChange={item => toogleDateRange(item,true)}
          
          calendarFocus={'backwards'}
          ranges={compare?[rangesVirtual.principal,rangesVirtual.compare]:[rangesVirtual.principal]}
          ariaLabels={{
            dateInput: {
              principal: { startDate: "principal_start", endDate: "principal_end" },
              compare: { startDate: "compare_start", endDate: "compare_end" }
            },
          }}
        />
      </div>
      
        
    </div>

    <div 
      id="buttons-container" 
      className = "cc-border-top"
      style={{ width:'100%',display:'flex', justifyContent:'end', padding:'8px 0'}}
    >
      <Button onClick={props.cancel} margin={'0 8px'}>Cancelar</Button>
      <Button flat onClick={handleApply} margin={'0 8px'}>Aplicar</Button>
    </div>
  
  </div>
  );
}

export default CalendarComplex;